export default __webpack_public_path__ + "static/media/love.15c32332.svg";